export const formattedSize = (size: number) => {
  if (size < 1024) {
    return `${size.toFixed(1)} KB`;
  }
  return `${(size / 1024).toFixed(2)} MB`;
};

export const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
